export default "__VITE_ASSET__8277fa6d__"